import React from 'react';

export interface AddressSummaryProps {
  inline: boolean;
  store: {
    address1: string;
    address2: string;
    city: string;
    province: string;
    zip: string;
    country: string;
  };
}
export const AddressSummary: React.FC<AddressSummaryProps> = ({
  inline,
  store,
}) => {
  let components: React.ReactNode[] = [];
  if (inline) {
    let address = store.address1;

    if (store.address2) {
      address = `${address}, ${store.address2}`;
    }

    if (store.city) {
      address = `${address}, ${store.city}`;
    }

    if (store.province) {
      address = `${address}, ${store.province}`;
    }

    if (store.zip) {
      address = `${address}, ${store.zip}`;
    }

    if (store.country) {
      address = `${address}, ${store.country}`;
    }

    components = [address];
  } else {
    components = [<div key="line1">{store.address1}</div>];

    if (store.address2) {
      components.push(<div key="line2">{store.address2}</div>);
    }

    if (store.city && store.province && store.zip) {
      components.push(
        <div key="line3">{`${store.city}, ${store.province}, ${store.zip}`}</div>,
      );
    } else if (store.city && store.province) {
      components.push(
        <div key="line3">{`${store.city}, ${store.province}`}</div>,
      );
    } else if (store.city && store.zip) {
      components.push(<div key="line3">{`${store.city}, ${store.zip}`}</div>);
    } else if (store.province && store.zip) {
      components.push(
        <div key="line3">{`${store.province}, ${store.zip}`}</div>,
      );
    } else if (store.city) {
      components.push(<div key="line3">{store.city}</div>);
    } else if (store.province) {
      components.push(<div key="line3">{store.province}</div>);
    } else if (store.zip) {
      components.push(<div key="line3">{store.zip}</div>);
    }

    if (store.country) {
      components.push(<div key="line4">{store.country}</div>);
    }
  }

  if (inline) {
    return <div>{components}</div>;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>{components}</div>
  );
};
